import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CONTACT_FALLBACK } from "@/data/catalog";

const ContactContext = createContext(CONTACT_FALLBACK);
export const useContact = () => useContext(ContactContext);

export function ContactProvider({ children }) {
  const [contact, setContact] = useState(CONTACT_FALLBACK);
  useEffect(() => {
    api
      .get("/contact-info")
      .then(({ data }) => setContact({ ...CONTACT_FALLBACK, ...data }))
      .catch(() => {});
  }, []);
  return <ContactContext.Provider value={contact}>{children}</ContactContext.Provider>;
}
